<template>
    <div class="page-nav-container">
        <div class="nav" v-show="pageNavList.length > 0">
            <i class="icon iconfont icon-dingwei"></i>
            <span>当前位置：</span>
            <div class="nav-item" @click="goHome()">首页</div>
            <div class="items" v-for="(item, i) in pageNavList" :key="i">
                <div class="nav-i">&nbsp;>&nbsp;</div>
                <div class="nav-item" v-if="i + 1 != pageNavList.length" @click="toPage(i)">{{item.name}}</div>
                <div class="nav-item isactive" v-if="i + 1 == pageNavList.length">{{item.name}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PageNavP',
    data() {
        return {
            pageNavList: []
        }
    },
    created() {
        let data = this.cm.getSessionData('pageNavList');
        console.log('pageNavList>>>', data);
        if(data) {
            this.pageNavList = data;
        }
        this.Bus.$on('pageNav', (data) => {
            console.log('datapageNav>>>', data);
            if(data) {
                // data.isPush为true则push进原数组,为false则直接赋值给原数组.
                let flag = true;
                if(data.isPush) {
                    let dataList = JSON.parse(JSON.stringify(this.pageNavList));
                    if(dataList.length > 0) {
                        for(let i = 0; i < dataList.length; i++) {
                            console.log(dataList[i].name, data.pathObj.name)
                            if(dataList[i].name == data.pathObj.name) {
                                flag = false;
                                // this.pageNavList.push(data.pathObj);
                            }
                        }
                    }
                    if(flag) {
                        this.pageNavList.push(data.pathObj);
                    }
                } else {
                    this.pageNavList = [data.pathObj];
                }
                // data.isPush ? this.pageNavList.push(data.pathObj) : this.pageNavList = [data.pathObj];
                // console.log('pageNavList>>>', this.pageNavList);
            } else {
                this.pageNavList = [];
            }
            this.setPageNavList();
        });
    },
    methods: {
        goHome() {
            // 生成页面“当前位置”导航
            this.pageNavList = [];
            this.setPageNavList();
            // 跳转页面
            this.cm.toPage('homep', 0);
        },
        toPage(i) {
            let item = this.pageNavList[i];
            let pageName = item.path, navStatus = item.navStatus;
            if(item.haveParmas == 'y') {
                let pageDataObj = item.sessionData ? item.sessionData : {};
                this.cm.toPage(pageName, navStatus, pageDataObj);
            } else {
                this.cm.toPage(pageName, navStatus);
            }
            this.pageNavList.splice(i + 1, this.pageNavList.length);
            this.setPageNavList();
        },
        setPageNavList() {
            this.cm.setSessionData('pageNavList', this.pageNavList);
        }
    }
}
</script>
<style lang="scss" scoped>
@import './PageNavP.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/page-nav/PageNavP.vue